function r(e) {
  switch (e.type) {
    case "fade_in":
      return "fade-in";
    case "slide_in":
      switch (e.direction) {
        case "down":
          return "slide-in-down";
        case "up":
          return "slide-in-up";
        case "left":
          return "slide-in-left";
        case "right":
          return "slide-in-right";
        default:
          return "slide-in-up";
      }
    case "scale_in":
      switch (e.scaleTo) {
        case "grow":
          return "scale-in-grow";
        case "shrink":
          return "scale-in-shrink";
        default:
          return "scale-in-grow";
      }
    default:
      return;
  }
}
export {
  r as getAnimationClassName
};
